module.exports = __webpack_public_path__ + "img/img4.17734def.svg";